import React, { useLayoutEffect, useRef } from 'react';

import { ReactComponent as LoaderSvg } from '../../../../../common/assets/Loader.svg';

type Props = {
  'aria-label': string;
};

// Loader.svg uses SMIL animation; pause via pauseAnimations() once inlined (CSS animation-play-state alone is not enough).
const PausedLoaderIcon = ({ 'aria-label': ariaLabel }: Props): JSX.Element => {
  const rootRef = useRef<HTMLSpanElement>(null);

  useLayoutEffect(() => {
    const svg = rootRef.current?.querySelector('svg');
    svg?.pauseAnimations?.();
  }, []);

  return (
    <span ref={rootRef} className="pacing-status-cell__loader">
      <LoaderSvg aria-label={ariaLabel} role="img" />
    </span>
  );
};

export default PausedLoaderIcon;
